"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const constants_1 = __importStar(require("../utils/constants"));
const _base_1 = require("./_base");
/**
 * ![PhysicalTableIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDE2IDEyLjQ2Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiAjZmZmOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8dGl0bGU+UGh5c2ljYWxUYWJsZTwvdGl0bGU+CiAgPGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+CiAgICA8ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPgogICAgICA8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xNSwwSDFBMSwxLDAsMCwwLDAsMVYxMS40NmExLDEsMCwwLDAsMSwxSDE1YTEsMSwwLDAsMCwxLTFWMUExLDEsMCwwLDAsMTUsMFpNNy41LDMuMTZWNi44MUgxVjMuMTZaTTEsNy44MUg3LjV2My42NUgxWk0xNSwxMnYtLjVIOC41VjcuODFIMTV2My42NWgwWm0wLTUuMTVIOC41VjMuMTZIMTVaIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K)
 */
exports.PhysicalTableIcon = (_a) => {
    var { size = 18, color } = _a, props = __rest(_a, ["size", "color"]);
    const iconColor = constants_1.expandColor(constants_1.default, color) || "currentColor";
    return (React.createElement(_base_1.Svg, Object.assign({ viewBox: "0 0 16 12.46", fill: iconColor, width: size, height: size, size: size, role: props.onClick ? "button" : undefined, tabIndex: props.onClick ? 0 : undefined }, props),
        React.createElement("path", { d: "M15 0H1a1 1 0 0 0-1 1v10.46a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM7.5 3.16v3.65H1V3.16zM1 7.81h6.5v3.65H1zM15 12v-.5H8.5V7.81H15v3.65zm0-5.15H8.5V3.16H15z" })));
};
//# sourceMappingURL=Icon.PhysicalTable.js.map